// extracted by mini-css-extract-plugin
export var footerElementTitle = "footer-table-menu-module--footerElementTitle--2k2tn";
export var footerListElement = "footer-table-menu-module--footerListElement--uRD+M";
export var tableMenu = "footer-table-menu-module--tableMenu--ZoHu9";
export var tableMenuItem = "footer-table-menu-module--tableMenuItem--U+jCx";
export var tableMenuLabel = "footer-table-menu-module--tableMenuLabel--OM1rq";
export var tableMenuSubLabel = "footer-table-menu-module--tableMenuSubLabel--4VqWh";